import React from 'react';
import { StepIcon, StepIconProps, useTheme } from '@mui/material';

export type ActivityStepIconProps = StepIconProps;

export const ActivityStepIcon = (props: ActivityStepIconProps) => {
  const theme = useTheme();
  const { completed, active } = props;

  return (
    <StepIcon
      {...props}
      icon={
        !completed && !active ? (
          <svg
            data-testid="task-in-progress-icon"
            className="task-in-progress-icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="#D5D7DA" strokeWidth="1" fill="white" />
          </svg>
        ) : active && !completed ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="active-task-in-progress-icon"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke={theme.palette.primary.main}
              strokeWidth="2"
              fill={theme.palette.primary.main}
            />
            <circle cx="12" cy="12" r="4" fill="#fff" />
          </svg>
        ) : completed && !active ? (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="white"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="task-completed-icon"
          >
            <path
              d="M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z"
              stroke={theme.palette.primary.main}
            />
            <path
              d="M16 9L10.5 14.5L8 12"
              stroke={theme.palette.primary.main}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="active-task-completed-icon"
          >
            <path
              d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
              fill={theme.palette.primary.main}
            />
            <path
              d="M16 9L10.5 14.5L8 12"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )
      }
    />
  );
};
